export const tableHeader = (t) => [
    {
      id: 'name',
      type: 'text',
      value: t('policy:page.table.name'),
    },
    {
      id: 'lastVersion',
      type: 'text',
      value: t('policy:page.table.version'),
    },
    {
      id: 'lastPolicyVersionPublishedDate',
      type: 'datetime',
      value: t('policy:page.table.published'),
    },
    {
      id: 'lastPolicyVersionStatus',
      type: 'text',
      value: t('policy:page.table.status'),
    },
    {
      id: 'action',
      type: 'actions-policy',
      value: '',
    },
  ]
